<template>
    <div class="platfroms">
        <!-- unpaid 是才显示 -->
        <!-- <div class="unpaid-tip" v-if="status == 1">
            <i class="el-icon-warning"></i>
            <span
                >Orders without shipping channels selected cannot be paid.</span
            >
        </div> -->
        <div class="store-items">
            <!-- <div
                class="store-item"
                :class="{ active: item.platform_id == storeId }"
                v-for="item of platformList"
                :key="item.platform_id"
                @click="chiocePlatform(item)"
            >
                <img
                    v-if="item.platform_code"
                    :src="
                        require('@/assets/image/goods/' +
                            item.platform_code +
                            '.png')
                    "
                />
                <p class="store-num" v-if="item.count">{{ item.count }}</p>
            </div> -->
            <div class="tip">
                <i class="el-icon-warning"></i>
                <span>{{ $t("storeList.add.tip") }}</span>
            </div>
        </div>
        <div class="store-items" v-if="['1', '10'].includes(status)">
            <div class="notice">
                <span>Careful：If the order does not have this symbol </span>
                <i class="el-icon-s-help" style="color: #fc8540;font-size:16px;padding:0 5px"></i>
                <span> , it means that SKU is not completely matched. Please contact your sales manager to update SKU before order payment</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        /* storeId: {
      type: Number,
      default: 0,
    }, */
        platformList: {
            type: Array,
            default: () => [],
        },
        status: String
    },
    data() {
        return {
            storeId: 0,
        };
    },
    methods: {
        chiocePlatform(item) {
            this.storeId = item.platform_id;
            this.$emit("chiocePlatform", item);
        },
    },
};
</script>

<style lang="scss" scoped>
.platfroms {
    margin: 0 15px 7px;
    text-align: left;
    .store-items {
        //display: flex;
        flex-wrap: wrap;
        .store-item {
            min-width: 100px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid #f3f3f3;
            border-radius: 6px;
            box-sizing: border-box;
            margin: 0 15px 0 0;
            cursor: pointer;
            padding: 0 15px;
            img {
                // max-width: 60%;
                width: 68px;
            }
            .store-num {
                margin-left: 20px;
                font-size: 16px;
                font-weight: 600;
                color: $color-primary-blue;
            }
            &:hover {
                box-shadow: 0 0 5px 0 rgba(200, 200, 200, 0.6);
            }
        }
        .active {
            border-color: $color-primary;
        }
        .shopify {
            img {
                width: 70%;
            }
        }
        .etsy {
            img {
                width: 40%;
            }
        }
        .amazon {
            img {
                width: 50%;
            }
        }
        .ebay {
            img {
                width: 45%;
            }
        }
    }

    .tip {
        padding: 8px 20px;
        font-size: 12px;
        color: #333;
        background-color: #e6f7ff;
        border: 1px solid #bee6ff;
        border-radius: 4px;
        align-self: center;
        display: flex;
        align-items: center;
        i.el-icon-warning {
            margin-right: 10px;
            color: #1890ff;
            font-size: 16px;
        }
    }
    .notice {
        margin-top: 10px;
        padding: 8px 20px;
        font-size: 12px;
        color:rgb(252, 8, 8);
        background-color: #f5dfe0;
        border: 1px solid #f8c9cb;
        border-radius: 4px;
        align-self: center;
        display: flex;
        align-items: center;
    }
    .unpaid-tip {
        margin-bottom: 10px;
        display: inline-block;
        padding: 8px 20px;
        font-size: 12px;
        color: #333;
        background-color: #e6f7ff;
        border: 1px solid #bee6ff;
        border-radius: 4px;
        i.el-icon-warning {
            margin-right: 10px;
            color: #1890ff;
            font-size: 16px;
        }
    }
}
</style>
